import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import { getAccountId } from '../../utils/helpers';
import * as billingActions from '../../modules/billing/actions';
import { makeSelectActiveBillingPeriod, makeSelectBillingPeriods } from '../../modules/billing/selectors';
import { ConfirmModal } from '../../components/ConfirmModal';
import businessProducts from '../../utils/products';
import _ from 'lodash';
import moment from 'moment';
import { TextModal } from '../../components/Modal';
import { Error } from '../../components/Error';
import { selectErrors } from '../../modules/global/selectors';
import { selectCustomerData, selectCustomerContactData } from '../../modules/customer/selectors';
import { makeSelectFetching, makeSelectCurrentSimFetchFinished, makeSelectSims, makeSelectCurrentSimData, makeSelectCurrentOrder } from '../../modules/sims/selectors';
import { makeSelectAllUsages, makeSelectSubUsage } from '../../modules/usage/selectors';

import * as simActions from '../../modules/sims/actions';
import * as customerActions from '../../modules/customer/actions';
import * as globalActions from '../../modules/global/actions';
import * as usageActions from '../../modules/usage/actions';

import { SimInfoContent } from './SimInfoContent';
import { gaToggleAnsweringMachine, gaB2BToggleUnlimitedData } from '../../utils/analytics';
import consumerProducts from '../../utils/consumerProducts';

export class SimsInfoPage extends React.PureComponent {
	// eslint-disable-line react/prefer-stateless-function
	constructor(props) {
		super(props);

		this.state = {
			usageData: null,
			newSimName: '',
			data: {},
			selectedPrivacyOption: '',
			modalIsOpen: false,
			modalContent: '',
			confirmModalIsOpen: false,
			password: '',
			pollingSettingsCounter: 0,
			billingPeriodLength: null,
			daysIntoBillingPeriod: null,
			usageDataFetchStarted: false,
			currentSim: undefined,
			errorCounter: 0
		};
		this.delayedCallback = _.debounce(this.submitSimInfo, 1500);
		this.handleValidation = _.debounce(this.validate, 1500);
		this.pollingCurrentSim = _.debounce(this.pollCurrentSim, 5000);
	}

	componentDidMount() {
		const { fetchCustomerData, fetchCurrentSim, fetchCurrentOrder, fetchBillingPeriods, customer, fetchSims, sims } = this.props;
		fetchCurrentSim(this.getSimId());
		fetchCurrentOrder(getAccountId());
		if (!customer) {
			fetchCustomerData();
		}
		if (_.isEmpty(sims)) {
			fetchSims(getAccountId());
		}
		fetchBillingPeriods(getAccountId());
	}

	getSimId() {
		return this.props.match.params.id; // eslint-disable-line
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		const { fetchSubscriptionUsage, billingPeriods, errors } = this.props;
		// If we get currentSim in nextProps and it matches with sim id and its different with current sim in state,
		// we want to spread it to state. We need to exclude situations when its same with currentSim in state,
		// because we would end up here after password checking, and we would override setting state, we have set before
		// setting update api call
		if (nextProps.currentSim && this.getSimId() === nextProps.currentSim.id && (this.state.currentSim === undefined || nextProps.currentSim !== this.state.currentSim)) {
			this.setState({
				currentSim: nextProps.currentSim,
				...nextProps.currentSim
			});
			this.pollingCurrentSim();
		}

		if (nextProps.subUsageData) {
			this.setState({
				usageData: _.find(nextProps.subUsageData.toJS().analysedSubscriptionUsages, (usageData) => usageData.subscriptionNumber === this.state.id)
			});
		}

		if (billingPeriods !== null && billingPeriods && billingPeriods.length > 0 && !this.state.usageDataFetchStarted) {
			const startDate = this.props.activeBillingPeriod ? this.props.activeBillingPeriod.startDate : billingPeriods[0].startDate;
			const endDate = this.props.activeBillingPeriod ? this.props.activeBillingPeriod.endDate : billingPeriods[0].endDate;
			fetchSubscriptionUsage(this.getSimId(), startDate, endDate);
			this.setState({
				usageDataFetchStarted: true
			});
		}

		// If we fail to update options
		// (we receive new error comparing to ones in props)
		// (if we would receive two errors at same time, which is unlikely, we would ignore it just in case to not make wrong conclusion),
		// we need to fetch current sim to update toggle states because before option update we set that option to show
		// new state and disable it until it's updated
		if (nextProps.errors && nextProps.errors.length - errors.length === 1) {
			const newErrorEndpointAndQueryParameters = nextProps.errors[nextProps.errors.length - 1].endpointAndQueryParameters;
			if (newErrorEndpointAndQueryParameters.includes('/options/update/')) {
				if (this.state.errorCounter < 10) {
					this.setState({
						errorCounter: this.state.errorCounter + 1
					});
					this.props.pollCurrentSim(this.getSimId());
				} else {
					// If for some reason latest error wouldn't be last on the list and fetching current sim would fail,
					// we could end up with infinity loop, so to avoid that scenario we'll do page refresh when entering
					// here too often
					_.delay(() => {
						window.location.reload();
					}, 5000);
				}
			}
		}
	}

	componentWillUnmount() {
		this.pollingCurrentSim.cancel();
		this.props.clearCurrentSim();
	}

	getActiveBillingPeriodValue = () => {
		const { billingPeriods, activeBillingPeriod } = this.props;
		if (activeBillingPeriod !== null) {
			return activeBillingPeriod;
		} else if (billingPeriods !== null) {
			return billingPeriods[0];
		}
		return null;
	};

	doUpdateSim = (password) => {
		const data = this.state.data;
		const settingName = Object.keys(data.settings)[0];
		const { updateSim, accountType } = this.props;
		if (settingName !== 'usePhoneDirectoryOwner') {
			data.settings[settingName].updating = true;
		} else {
			const phoneDirectoryUser = this.state.phoneDirectoryUserInfo;
			phoneDirectoryUser.publishOwner = data.settings[settingName].value;
			phoneDirectoryUser.publishOwnerUpdating = true;
			this.setState({
				phoneDirectoryUserInfo: phoneDirectoryUser
			});
		}
		let updateSimContent = { id: data.settings[settingName].name, value: data.settings[settingName].value };
		if (password !== undefined) {
			updateSimContent.password = password;
		}
		this.setState(
			{
				settings: {
					...this.state.settings,
					...data.settings
				}
			},
			() => {
				updateSim(this.getSimId(), updateSimContent);
			}
		);
		if (data.settings[settingName].name === 'voiceMail') {
			let priceChange;
			if (accountType === 'consumer') {
				priceChange = data.settings[settingName].value ? consumerProducts.getSimVoiceMailPrice() : -1 * consumerProducts.getSimVoiceMailPrice();
			} else {
				priceChange = data.settings[settingName].value ? businessProducts.getSimVoiceMailPrice() : -1 * businessProducts.getSimVoiceMailPrice();
			}
			gaToggleAnsweringMachine(data.settings[settingName].value, priceChange);
		}
		if (data.settings[settingName].name === 'unlimitedData') {
			const priceChange = data.settings[settingName].value ? businessProducts.getSimUnlimitedDataPrice() : -1 * businessProducts.getSimUnlimitedDataPrice();
			gaB2BToggleUnlimitedData(data.settings[settingName].value, priceChange);
		}
	};

	pollCurrentSim = () => {
		if (this.isSettingUpdateNeeded()) {
			this.setState({
				pollingSettingsCounter: this.state.pollingSettingsCounter + 1
			});
			this.props.pollCurrentSim(this.getSimId());
		}
	};

	handleChange = (data) => {
		const settingName = Object.keys(data.settings)[0];
		const { updateSim } = this.props;
		if (data.settings && data.settings.unlimitedData) {
			this.setState({
				modalIsOpen: true,
				modalContent: `Haluatko varmasti asettaa rajattoman datan ${data.settings.unlimitedData.value === true ? 'päälle' : 'pois päältä'}`,
				data
			});
		} else if (data.settings && data.settings.voiceMail) {
			this.setState({
				modalIsOpen: true,
				modalContent: `Haluatko varmasti asettaa vastaajan ${
					data.settings.voiceMail.value === true ? 'päälle' : 'pois päältä? Huomioithan, että jos myöhemmin haluat vastaajan uudelleen päälle luodaan uusi vastaaja numero.'
				}`,
				data
			});
		} else if (data.settings && data.settings.suspendSubscriptionTemporarily) {
			this.setState({
				confirmModalIsOpen: true,
				data
			});
		} else if (data.settings) {
			this.setState(
				{
					data
				},
				() => {
					this.doUpdateSim();
				}
			);
		} else {
			this.setState(
				{
					...data
				},
				() => {
					updateSim(
						this.getSimId(),
						{ id: data.settings[settingName].name, value: data.settings[settingName].value },
						{
							debounce: true
						}
					);
				}
			);
		}
		this.setState({
			pollingSettingsCounter: 0
		});
	};

	handleSimNameChange = (simName) => {
		this.setState({
			newSimName: simName
		});
		const updates = [
			{
				field: 'name',
				value: simName
			}
		];
		this.delayedCallback(updates);
	};

	simCustomerInfoChangeHandler = (field, value) => {
		if (field === 'phone-directory-zip-code') {
			this.handleValidation(field, value);
		} else {
			const updates = [
				{
					field,
					value
				}
			];
			this.delayedCallback(updates);
		}
	};

	validate = (field, value) => {
		const regex = /^[0-9]{5}$/;
		const valid = regex.test(value);
		if (valid) {
			this.setState({
				showErrors: false
			});
			const updates = [
				{
					field,
					value
				}
			];
			this.delayedCallback(updates);
		} else {
			this.setState({
				showErrors: true
			});
		}
		if (value.length < 1) {
			this.setState({
				showErrors: false
			});
		}
	};

	submitSimInfo = (updates) => {
		const { updateSimInfo } = this.props;
		updateSimInfo(this.getSimId(), { updates });
	};

	isSettingUpdateNeeded = () => {
		if (this.props.settingsDisabled) return false;
		if (this.state.pollingSettingsCounter > 25) return false;
		if (this.props.currentSim === null) return false;
		const res = _.find(this.props.currentSim.settings, (setting) => setting.updating && !setting.changeAppliedDate);
		return res !== undefined;
	};

	closeModal = () => {
		this.setState({
			modalIsOpen: false
		});
	};

	closeConfirmModal = () => {
		this.setState({
			confirmModalIsOpen: false,
			password: ''
		});
	};

	handlePassword = (e) => {
		this.setState({
			password: e.target.value
		});
	};

	doSubmitWithPassword = () => {
		const password = this.state.password;
		this.setState({
			confirmModalIsOpen: false,
			password: ''
		});
		this.doUpdateSim(password);
	};

	updateBillingPeriod = (billingPeriod) => {
		const { setActiveBillingPeriod, fetchSubscriptionUsage } = this.props;
		const start = moment(billingPeriod.startDate);

		const daysFromStart = moment().diff(start, 'days');
		const periodLength = businessProducts.getEstimatePeriodLength(billingPeriod.startDate, billingPeriod.endDate);

		this.setState({
			selectedBillingPeriod: {
				startDate: billingPeriod.startDate,
				endDate: billingPeriod.endDate
			},
			billingPeriodLength: periodLength,
			daysIntoBillingPeriod: Math.min(daysFromStart, periodLength)
		});

		setActiveBillingPeriod(billingPeriod);
		fetchSubscriptionUsage(this.getSimId(), billingPeriod.startDate, billingPeriod.endDate);
	};

	doPollCurrentSim = () => {
		this.props.pollCurrentSim(this.getSimId());
	};

	render() {
		const { currentSim, fetching, currentSimFetchFinished, customerContactData, billingPeriods, customer, errors, currentOrder, sims, accountType, offeringType } = this.props;
		const settingsDisabled = this.props.settingsDisabled !== undefined ? this.props.settingsDisabled : true;
		const canShowSubscription = (!currentSimFetchFinished || currentSim) && _.find(errors, (error) => error.endpointAndQueryParameters.includes('subscriptions')) === undefined;
		const canShowUsage =
			!_.isNil(this.state.usageData) &&
			!_.isNil(billingPeriods) &&
			_.find(errors, (error) => error.endpointAndQueryParameters.includes('detailed-subscription-usage') || error.endpointAndQueryParameters.includes('billing-periods')) === undefined;
		let dataPerSim;
		let moisPerSim;
		let moisTotal;
		let dataTotal = null;
		if (!_.isNil(currentOrder) && !_.isNil(sims)) {
			dataPerSim = currentOrder.dataPerSim;
			moisPerSim = currentOrder.moisPerSim;
			moisTotal = businessProducts.getMoisPackageTotal(moisPerSim, sims.length);
			dataTotal = businessProducts.getDataPackageTotal(dataPerSim, sims.length);
		}
		let usageData = null;
		if (canShowUsage) {
			const vasCallsTotal = this.state.usageData.vasCallsTotalVatIncluded;
			const vasAppTotal = this.state.usageData.vasAppTotalVatIncluded;
			const vasMsgTotal = this.state.usageData.vasMsgTotalVatIncluded;
			const roamingTotal = this.state.usageData.roamingTotalVatIncluded;
			const euData = this.state.usageData.usedEuData;
			const data = Number(parseFloat(this.state.usageData.usedDomesticData).toFixed(2));
			const mois = this.state.usageData.usedMoisEur;
			const additionalServicesTotal = roamingTotal + vasCallsTotal + vasAppTotal + vasMsgTotal;
			const voice = this.state.usageData.usedDomesticCalls;
			const message = this.state.usageData.usedDomesticSms;
			const roamingEuros = this.state.usageData.roamingTotalVatExcluded;
			const serviceEuros = this.state.usageData.vasTotalVatExcluded;

			if (accountType === 'consumer') {
				usageData = {
					data,
					mois,
					roamingTotal,
					vasCallsTotal,
					vasAppTotal,
					vasMsgTotal,
					additionalServicesTotal,
					euData
				};
			}
			if (accountType === 'business') {
				usageData = {
					data,
					voice,
					message,
					roamingEuros,
					serviceEuros,
					euData
				};
			}
		}
		const ready = !fetching && currentSim && currentOrder;
		return (
			<article>
				<Helmet title="Simmi" meta={[{ name: 'description', content: '' }]} />
				<TextModal isOpen={this.state.modalIsOpen} onRequestClose={this.closeModal} content={this.state.modalContent} doConfirm={this.doUpdateSim} />
				<ConfirmModal
					isOpen={this.state.confirmModalIsOpen}
					onRequestClose={this.closeConfirmModal}
					onConfirm={this.doSubmitWithPassword}
					onPasswordChange={this.handlePassword}
					title={'Vahvista muutos Moin salasanallasi'}
					password={this.state.password}
				/>
				{!canShowSubscription && <Error message={'Liittymän tietoja ei löytynyt'} />}
				{ready && customer && (
					<div>
						<SimInfoContent
							accountType={this.props.accountType}
							settingsDisabled={settingsDisabled}
							settingsDisabledNotification={this.props.settingsDisabledNotification}
							phoneDirectoryOwnerInfo={customer.toJS().phoneDirectoryOwnerInfo}
							{...this.state}
							activeBillingPeriod={this.getActiveBillingPeriodValue()}
							onChange={this.handleChange}
							simNameChangeHandler={this.handleSimNameChange}
							simInfoUpdataHandler={this.submitSimInfo}
							simClientInfoChangeHandler={this.simCustomerInfoChangeHandler}
							dataTotal={dataTotal}
							moisTotal={moisTotal}
							getDataUsage={this.getDataUsage} // not in use?
							getEstimate={this.getEstimate} // not in use?
							getWarningValue={businessProducts.getWarningValue}
							getMaxValue={this.getMaxValue}
							usageData={usageData}
							billingPeriods={billingPeriods}
							updateBillingPeriod={this.updateBillingPeriod}
							offeringType={offeringType}
							customerContactData={customerContactData}
							pollCurrentSim={this.doPollCurrentSim}
						/>
					</div>
				)}
			</article>
		);
	}
}

SimsInfoPage.propTypes = {
	accountType: PropTypes.string,
	billingPeriods: PropTypes.array,
	activeBillingPeriod: PropTypes.object,
	fetching: PropTypes.bool.isRequired,
	fetchCurrentSim: PropTypes.func.isRequired,
	updateSimInfo: PropTypes.func.isRequired,
	updateSim: PropTypes.func.isRequired,
	currentSim: PropTypes.object,
	location: PropTypes.object,
	customer: PropTypes.object,
	currentOrder: PropTypes.object,
	sims: PropTypes.array,
	fetchCustomerData: PropTypes.func,
	customerContactData: PropTypes.object,
	settingsDisabled: PropTypes.bool,
	clearCurrentSim: PropTypes.func,
	errors: PropTypes.array,
	pollCurrentSim: PropTypes.func,
	fetchBillingPeriods: PropTypes.func,
	fetchCurrentOrder: PropTypes.func,
	fetchSims: PropTypes.func,
	currentSimFetchFinished: PropTypes.bool.isRequired,
	fetchSubscriptionUsage: PropTypes.func,
	setActiveBillingPeriod: PropTypes.func,
	settingsDisabledNotification: PropTypes.string,
	offeringType: PropTypes.string
};

const makeMapStateToProps = () => {
	const selectFetching = makeSelectFetching();
	const selectCurrentSimFetchFinished = makeSelectCurrentSimFetchFinished();
	const SelectCurrentSimData = makeSelectCurrentSimData();
	const selectBillingPeriods = makeSelectBillingPeriods();
	const selectActiveBillingPeriod = makeSelectActiveBillingPeriod();
	const selectCurrentOrder = makeSelectCurrentOrder();
	const selectSims = makeSelectSims();
	const selectAllUsages = makeSelectAllUsages();
	const selectSubUsage = makeSelectSubUsage();

	return (state) => {
		const customer = selectCustomerData(state);
		const customerContactData = selectCustomerContactData(state);
		const billingPeriods = selectBillingPeriods(state);
		const activeBillingPeriod = selectActiveBillingPeriod(state);
		const errors = selectErrors(state);
		const currentOrder = selectCurrentOrder(state);
		const sims = selectSims(state);

		return {
			fetching: selectFetching(state),
			currentSimFetchFinished: selectCurrentSimFetchFinished(state),
			currentSim: SelectCurrentSimData(state),
			customer,
			customerContactData,
			billingPeriods,
			activeBillingPeriod,
			errors,
			currentOrder,
			sims,
			allUsagesData: selectAllUsages(state),
			subUsageData: selectSubUsage(state)
		};
	};
};

const mapDispatchToProps = {
	...globalActions,
	...simActions,
	...customerActions,
	...billingActions,
	...usageActions
};

export default connect(makeMapStateToProps, mapDispatchToProps)(withRouter(SimsInfoPage));
